import { render, staticRenderFns } from "./JsonSetting.vue?vue&type=template&id=37efc972&"
import script from "./JsonSetting.vue?vue&type=script&lang=js&"
export * from "./JsonSetting.vue?vue&type=script&lang=js&"
import style0 from "./JsonSetting.vue?vue&type=style&index=0&id=37efc972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports